
$(document).ready(function(){

$(".slick-track").removeAttr("role");

$(".announcement-slider__slide, .slick-track .starting-slide").removeAttr("aria-describedby");
$(".slick-track, .announcement-slider__slide, .slick-dots li, .slick-dots").removeAttr("role");
$("#AnnouncementSlider .slick-list").removeAttr("aria-live");
$(".slick-dots li").removeAttr("aria-hidden");
$(".grid--uniform.visually-invisible").removeAttr("aria-hidden");
$(".slick-dots li").removeAttr("aria-controls");
$(".slick-dots li").removeAttr("aria-selected");
$(".product__photo-zoom").attr("aria-hidden", "true");
$(".splide--slide").removeAttr("aria-labelledby");
$(".splide__list .splide__slide").removeAttr("role");
$(".splide__list").removeAttr("role");
$(".site-nav__icons a").removeAttr("aria-controls");
$(".product__photos .product__thumb-item, .product__main-photos .slick-slide").removeAttr("aria-describedby");
$(".product__main-photos .slick-slide").removeAttr("role");




if ($(window).width() < 769) {
   $(".site-header__logo-link.logo--inverted .small--hide").attr("aria-hidden", "true");
   $(".site-header__logo-link.logo--inverted .medium-up--hide").attr("aria-hidden", "false");
}
else {
  $(".site-header__logo-link.logo--inverted .small--hide").attr("aria-hidden", "false");
$(".site-header__logo-link.logo--inverted .medium-up--hide").attr("aria-hidden", "true");
}

$("br").attr("aria-hidden", "true");
$(".site-footer li a[href='/pages/accessibility']").attr("id", "skipliknktext");

$(".product__photos .product__thumb-item").removeAttr("aria-hidden");
$(".site-nav__link--has-dropdown").removeAttr("href");
$(".site-nav__link--has-dropdown").attr("role", "button");
$(".site-nav__link--has-dropdown").attr("aria-expanded", "false");

$("#ProductThumbs-.splide__list li").removeAttr("tabindex");
$("#ProductThumbs-.splide__list li").attr("role", "button");
$(".card.description #productDescriptionBody").removeAttr("aria-labelledby");
$(".card.details #productDetailsBody").removeAttr("aria-labelledby");

// dropdown

$(".site-nav__link--has-dropdown").click(function(){

  $(this).parent().children(".site-nav__dropdown").toggleClass("usm");

  $(this).attr('aria-expanded', function(i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });

});



  $(".js-search-header-close").on("click", function () {
    setTimeout(function () {
      $(".searchicbtn").attr("tabindex", 0).focus();
    }, 1000);
  });




});


// $(document).ready(function () {
//   setTimeout(function () {
   

//     $("picture img").attr("alt", "half img");

//   }, 3000);
//   }, 3000);



  // backtotopbtn

$(document).ready(function() {
  var backToTopButton = $('#go-top');
  backToTopButton.hide();
  $(window).scroll(function() {
      if ($(this).scrollTop() > 300) {
          backToTopButton.show();
      } else {
          backToTopButton.hide();
      }
  });
  
  backToTopButton.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      
      // Set focus to the top of the page or the button itself after scrolling
      setTimeout(function() {
          // $('#backtotop').focus(); // If focusing the top element
          // backToTopButton.focus(); // If focusing the button itself
      }, 600); // Adjust the timeout duration to match the scroll duration
  });
});



// Handle focus events for VoiceOver
$(document).on('focusin', function(event) {
  // Check if the focus is outside of elements with class "site-nav--has-dropdown"
  if ($(event.target).closest(".site-nav__dropdown").length === 0) {
    // Close all dropdowns by setting their "aria-expanded" attribute to "false"
    $(".site-nav__link--has-dropdown").attr("aria-expanded", "false");
    $(".site-nav__dropdown").removeClass("usm");
    
    // Add your code to hide the dropdown menu as needed here
  }
});


$( document ).ready(function() {
  //wait until the last element (#checkout-step-shipping_method) being rendered
  var existCondition = setInterval(function() {
   if ($('picture img').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 200);

  function runMyFunction2(){
   console.log("Customer Email Laoding");

   $("picture img").attr("alt", "half img");
   
  }
}); 




$( document ).ready(function() {
  var existCondition = setInterval(function() {
   if ($('.slick-track').length) { 
    clearInterval(existCondition);
    runMyFunction2();
   }
  }, 2000);

  function runMyFunction2(){
   console.log("Slider Loaded");
   $('.product__thumb-item.slick-slide').attr('aria-hidden', 'false');
   $('.product__thumb-item.slick-slide.slick-active').attr('aria-hidden', 'false');
   $(".slick-slide").removeAttr("role");
   $(".slick-slide").removeAttr("tabindex");
  }
}); 

document.addEventListener('DOMContentLoaded', function() {
  // Function to update aria-hidden based on the active class
  function updateAriaHidden() {
      var slides = document.querySelectorAll('.product__thumb-item');
      var slides2 = document.querySelectorAll('.slick-track');
      var slides3 = document.querySelectorAll('.product__main-photos .slick-slide');
      slides.forEach(function(slide) {
          if (slide.classList.contains('slick-slide')) {
              // If the slide has the active class, set aria-hidden to false
              slide.setAttribute('aria-hidden', 'false');
              
          } else {
              // Otherwise, set aria-hidden to true
              slide.setAttribute('aria-hidden', 'false');
              
          }
          slide.removeAttribute('role');
          slide.removeAttribute('tabindex');
          
      });


      slides2.forEach(function(slide) {
        
        slide.removeAttribute('role'); 
    });

    slides3.forEach(function(slide) {
      slide.removeAttribute('role'); 
      slide.removeAttribute('tabindex');
  });

  }

  // Select the navigation buttons
  var navButtons = document.querySelectorAll('.product__thumb-item');

  // Event listeners for click events on navigation buttons
  navButtons.forEach(function(button) {
      button.addEventListener('click', function() {
          // Wait for the slider to update the active class
          setTimeout(updateAriaHidden, 1000); // Adjust the timeout as needed
      });
  });

  // Initial update when the page loads
  updateAriaHidden();
});


$(document).on("click", ".js-no-transition", function () {
  // 'this' is the element with '.js-no-transition' that was clicked
  
  setTimeout(function () {
    // Find the '.tag--active' element within the context of the clicked '.js-no-transition'
    $(".tag--active").attr("tabindex", 0).focus();
  }, 1000);
});


$(document).ready(function() {
  // Store the menu element
  var $menu = $('#shopify-section-page-faq-template .collapsible-trigger');
  var $cocn = $('#shopify-section-page-faq-template .collapsible-content');  
  // Close the menu on Escape key press
  $(document).keydown(function(event) {
    if (event.key === 'Escape') {
      $menu.removeClass('is-open');
      $cocn.removeClass('is-open');
      $cocn.css("height", "0px");
      $('#shopify-section-page-faq-template .collapsible-trigger').attr('aria-expanded', 'false');
    }
  });
});



$(document).ready(function(){


  function extractProductName(dataHref) {
    const start = dataHref.indexOf('/products/') + 10; // Length of '/products/' is 10
    const end = dataHref.indexOf('?variant');
    return dataHref.substring(start, end).replace(/[_-]/g, ' '); // Replacing underscores or hyphens with spaces
}

// Function to replace background image div with img tag
function replaceBackgroundImageWithImg() {
    // Get the product title text
    const productTitle = document.querySelector('.product-single__title').innerText;

    // Select all div elements with the class name
    const backgroundImageDivs = document.querySelectorAll('.cbb-frequently-bought-product-image');

    backgroundImageDivs.forEach(div => {
        // Get the parent 'a' tag if it exists
        const parentLink = div.closest('.cbb-frequently-bought-product-image-link');
        
        // Extract the background image URL
        const backgroundImage = div.style.backgroundImage;
        const imageUrl = backgroundImage.slice(5, -2); // Remove 'url(' and ')'
        
        // Initialize alt text
        let altText = '';

        // If the parent link exists and has a 'data-href' attribute, extract product name
        if (parentLink && parentLink.hasAttribute('data-href')) {
            const dataHref = parentLink.getAttribute('data-href');
            altText = extractProductName(dataHref);
        } else {
            // If no parent link, use the product title
            altText = productTitle;
        }

        // Create the img tag
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = altText;
        
        // Set width and height from the div style
        img.style.width = div.style.width;
        img.style.height = div.style.height;
        
        // If the div is wrapped with an 'a' tag, replace the div inside the 'a' tag
        // Otherwise, replace the div itself
        if (parentLink) {
            parentLink.replaceChild(img, div);
        } else {
            div.parentNode.replaceChild(img, div);
        }
    });
}

// Run the function after a delay of 3 seconds (3000 milliseconds)
setTimeout(replaceBackgroundImageWithImg, 3000);


});